module.exports = __webpack_public_path__ + "static/media/microservices.54918858.svg";